import React from "react";
import Reveal from "@/components/places/Reveal";
import SEO from "@/components/places/SEO";

export default function Privacidade() {
  return (
    <section className="theme-light pt-36 pb-24 min-h-screen">
      <SEO
        title="Política de Privacidade"
        description="Política de privacidade da Places em conformidade com a LGPD. Como coletamos, utilizamos e protegemos seus dados."
        noindex={false}
        breadcrumbs={[
          { name: "Home", url: typeof window !== "undefined" ? window.location.origin + "/" : "/" },
          { name: "Privacidade", url: typeof window !== "undefined" ? window.location.href : "/privacidade" },
        ]}
      />
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <h1 className="font-display text-5xl md:text-7xl mb-8">Política de Privacidade</h1>
          <div className="article-content text-neutral-700">
            <p>Esta Política de Privacidade descreve como a Places coleta, utiliza, armazena e protege os dados pessoais dos visitantes deste site, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018).</p>
            <h2>1. Dados coletados</h2>
            <p>Coletamos dados quando você preenche o formulário de contato (nome, e-mail, telefone, empresa, mensagem) ou utiliza o concierge de IA. Também coletamos dados de navegação anonimizados via cookies de análise.</p>
            <h2>2. Uso dos dados</h2>
            <p>Utilizamos as informações para responder ao seu contato, oferecer recomendações de serviços e melhorar a experiência no site. Não compartilhamos seus dados com terceiros sem o seu consentimento expresso.</p>
            <h2>3. Direitos do titular</h2>
            <p>Você pode, a qualquer momento, solicitar acesso, correção ou exclusão dos seus dados pessoais por meio do e-mail privacidade@agenciaplaces.com.br.</p>
            <h2>4. Cookies</h2>
            <p>Utilizamos cookies de funcionalidade e de análise. Você pode desabilitá-los no seu navegador a qualquer momento.</p>
            <h2>5. Contato</h2>
            <p>Para dúvidas relacionadas à privacidade, escreva para privacidade@agenciaplaces.com.br.</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
